import { Component, Input, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { ExpertGroupPortal } from 'src/app/shared/interfaces/expert-group-portal.interface'
import { Page } from 'src/app/shared/interfaces/page.interface'
import { Post } from 'src/app/shared/interfaces/resources/post.interface'
import { TaxonomyTerm } from 'src/app/shared/interfaces/taxonomy-term.interface'
import { Video } from 'src/app/shared/interfaces/video.interface'
import { PageService } from 'src/app/shared/services/page-service/page.service'
import { PostService } from 'src/app/shared/services/post.service'
import { TagService } from 'src/app/shared/services/tag.service'
import { VideoService } from 'src/app/shared/services/video.service'
import { ExpertGroupPortalService } from '../../services/expert-group-portal.service'

@Component({
  selector: 'app-expert-group-portal-resources-tabs',
  templateUrl: './expert-group-portal-resources-tabs.component.html',
  styleUrls: ['./expert-group-portal-resources-tabs.component.scss']
})
export class ExpertGroupPortalResourcesTabsComponent implements OnInit {
  @Input() selectedTabItem: string
  @Input() expertGroupPortal: ExpertGroupPortal

  hasMeetings: boolean
  hasVideos: boolean
  hasExternalResources: boolean
  hasPosts: boolean

  constructor(
    private videoService: VideoService,
    private pageService: PageService,
    private tagService: TagService,
    private postService: PostService,
    private expertGroupPortalService: ExpertGroupPortalService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    const portalId: string = this.router.url.split('/').slice(-2)[0]

    this.expertGroupPortal =
      await this.expertGroupPortalService.getExpertGroupPortalById(portalId)

    this.hasMeetings = await this.hasPageFeaturedCards(
      this.expertGroupPortal.slug + '-meeting-summaries'
    )

    this.hasExternalResources = await this.hasPageFeaturedCards(
      this.expertGroupPortal.slug + '-external-resources'
    )

    const tagPromises: Promise<TaxonomyTerm>[] =
      this.expertGroupPortal.tagSlugs.map((tagSlug) =>
        this.tagService.showBySlug(tagSlug)
      )

    const tags: TaxonomyTerm[] = await Promise.all(tagPromises)
    const tagIds: number[] = tags.map((tag) => tag.id)

    this.hasVideos =
      (
        (await this.videoService.list({
          tagIds,
          withoutPagination: true
        })) as Video[]
      ).length > 0

    this.hasPosts =
      ((await this.postService.listUnpaginated({ tagIds })) as Post[]).length >
      0
  }

  async hasPageFeaturedCards(pageSlug: string): Promise<boolean> {
    const page: Page = await this.pageService.show(pageSlug)

    console.log('FC IDS', page.id, page?.featuredCardIds?.length > 0)
    return page?.featuredCardIds?.length > 0
  }
}
